export default __webpack_public_path__ + "static/media/537.db8caeef.png";